import { memo, ReactNode, useContext, useMemo, useState } from "react";
import { FormikContext } from "formik";
import { FieldsScopeContext, useFieldsScopeContext } from "./FieldsScopeContext";
import { getObjectKeys } from "./utils";

export const ValidationScope = memo<{ children: ReactNode | ReactNode[] | ((value: boolean) => ReactNode) }>((
  {
    children,
  }) => {
  const { errors, touched, submitCount } = useContext(FormikContext) || {};
  const { registerField: externalRegisterField, unregisterField: externalUnregisterField } = useFieldsScopeContext();
  const [ store, setStore ] = useState<string[]>([]);

  const registerFieldContext = useMemo(() => ({
    registerField: (name: string) => {
      externalRegisterField(name);
      setStore(prevState => [ ...prevState, name ]);
    },
    unregisterField: (name: string) => {
      externalUnregisterField(name);
      setStore(prevState => prevState.filter(x => x !== name));
    },
  }), [ externalRegisterField, externalUnregisterField ]);

  const invalidFields = useMemo(() => submitCount > 0
    ? getObjectKeys(errors)
    : getObjectKeys(errors)
      .filter(fieldName => getObjectKeys(touched)
        .includes(fieldName),
      ), [ errors, touched, submitCount ]);

  const isValid = useMemo(
    () => !store.filter(path => invalidFields.includes(path)).length,
    [ store, invalidFields ],
  );

  return (
    <FieldsScopeContext.Provider value={registerFieldContext}>
      {typeof children === "function" ? children(isValid) : children}
    </FieldsScopeContext.Provider>
  );
});
